import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const painPoints = [{
  title: 'Llegás al final del día agotado pero sin rumbo',
  desc: 'Con una sensación de saturación extrema pero sin haber hecho lo importante.'
}, {
  title: 'Pensamientos que no progresan',
  desc: 'Un bucle mental constante (rumiación) del que no sabés cómo salir.'
}, {
  title: 'Te quemás la cabeza seguido',
  desc: 'Agotamiento mental crónico y dolores de cabeza por exceso de estímulos.'
}, {
  title: 'Siempre las mismas reacciones',
  desc: 'Te frustrás o te paralizás ante el menor imprevisto, viviendo en piloto automático.'
}, {
  title: 'Estabilidad inalcanzable',
  desc: 'Te falta un sistema estructurado para manejar el día a día.'
}, {
  title: 'Consejos sueltos de internet',
  desc: 'Probás meditación, respiraciones sueltas o tips de redes, pero nada respalda un cambio real.'
}, {
  title: 'Sin saber autorregularte',
  desc: 'Tu estabilidad emocional se vuelve un caos que depende 100% de los estímulos externos.'
}];
export function PainPoints() {
  return <section className="py-24 md:py-32 px-6 bg-charcoal text-cream border-t border-white/5" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="flex items-center gap-4 mb-6" data-id="element-130">
            <span className="text-3xl" data-id="element-131">🚨</span>
            <h2 className="text-sm tracking-widest uppercase text-terracotta font-semibold" data-id="element-132">
              ¿Te pasa esto seguido?
            </h2>
          </div>
          <h3 className="text-3xl md:text-5xl mb-16 leading-tight" data-id="element-133">
            Si vivís con ansiedad en el día a día, esto te va a sonar{' '}
            <span className="italic" data-id="element-134">dolorosamente familiar:</span>
          </h3>
        </FadeIn>

        <StaggerContainer className="space-y-0" data-id="element-135">
          {painPoints.map((point, i) => <StaggerItem key={i} data-id="element-136">
              <div className="py-6 md:py-8 border-b border-white/10 flex flex-col md:flex-row md:items-start gap-2 md:gap-8 group" data-id="element-137">
                <div className="text-terracotta/50 group-hover:text-terracotta transition-colors mt-1 hidden md:block" data-id="element-138">
                  —
                </div>
                <div data-id="element-139">
                  <h4 className="text-xl md:text-2xl font-serif mb-2" data-id="element-140">
                    {point.title}:
                  </h4>
                  <p className="text-cream/70 text-lg font-light leading-relaxed" data-id="element-141">
                    {point.desc}
                  </p>
                </div>
              </div>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn delay={0.2} className="mt-20 text-center" data-id="element-142">
          <p className="text-2xl md:text-4xl font-serif italic text-cream/90" data-id="element-143">
            ¿Cuántos meses más vas a vivir atrapado en el piloto automático?
          </p>
        </FadeIn>
      </div>
    </section>;
}